// extracted by mini-css-extract-plugin
module.exports = {"productImages":"_1M9G2","productImageWrapper":"_1eWmU","productImage":"_1m7Sk","productBadge":"wJW84"};